export enum ActionPromptEnum {
  APPROVE_TOP_UP_REQUEST = "APPROVE_TOP_UP_REQUEST",
  REJECT_TOP_UP_REQUEST = "REJECT_TOP_UP_REQUEST",
  REPAY_PARTIAL_TOP_UP_REQUEST = "REPAY_PARTIAL_TOP_UP_REQUEST",
  REPAY_COMPLETE_TOP_UP_REQUEST = "REPAY_COMPLETE_TOP_UP_REQUEST",
  APPROVE_QUICK_PAY_REQUEST = "APPROVE_QUICK_PAY_REQUEST",
  REJECT_QUICK_PAY_REQUEST = "REJECT_QUICK_PAY_REQUEST",
  REFUND_ADVANCED_PAYMENT_REQUEST = "REFUND_ADVANCED_PAYMENT_REQUEST",
}

export enum InputType {
  TEXT = 'text',
  EMAIL = 'email',
  OPTIONS = 'options',
  RADIO = 'radio',
  BOOLEAN = 'boolean',
  FILE = 'file',
  NUMBER = 'number',
  DATE = 'date'
}
